/**
 * This helper is used for delaying a UI render after calling an API
 * For example, we want to avoid displaying a loading screen and
 * hide it immediately after that
 */
const delayUIResponse = (callback: Function) => setTimeout(callback, 800);

export default delayUIResponse;
